import { __makeTemplateObject as n } from "../_virtual/_tslib.js";
import { jsxs as e, jsx as t } from "react/jsx-runtime";
import i from "styled-components";
import { Fonts as o } from "@vds-core/typography";
import { calculateRem as r, withVDSManager as a } from "@vds-core/utilities";
import { ColorTokens as l } from "@vds-tokens/color";
import { LayoutTokens as s } from "@vds-tokens/layout";
import { TypographyTokens as d } from "@vds-tokens/typography";
var u = l.elements.primary.onlight.value,
  p = l.elements.primary.ondark.value,
  c = d.fontweight.bold.value,
  f = d.fontweight.regular.value,
  g = r(s.space["4X"].value),
  h = r(s.space["3X"].value),
  m = r(s.space["2X"].value),
  y = r(s.space["1X"].value),
  v = r(s.space["3X"].value),
  b = r(s.space["2X"].value),
  w = i.li.withConfig({
    displayName: "StyledLi",
    componentId: "VDS__sc-1vrtxhi-0"
  })($ || ($ = n(["\n  ", ";\n  color: ", ";\n  outline: none;\n  list-style: none;\n  padding-top: ", ";\n  display: flex;\n\n  > span {\n    flex: 0 1 auto;\n    sup {\n      line-height: 0;\n    }\n  }\n\n  &:first-child {\n    padding-top: 0;\n  }\n\n  > span:first-child {\n    &:before {\n      content: '•';\n      font-weight: ", ";\n      padding-right: ", ";\n      flex-grow: 0;\n    }\n  }\n\n  ul {\n    padding: 0;\n    margin: 0;\n    flex-shrink: 0;\n\n    li {\n      list-style: none;\n\n      &:first-child {\n        padding-top: ", ";\n      }\n\n      > span:first-child {\n        &::before {\n          content: '–';\n          font-weight: ", ";\n        }\n      }\n    }\n  }\n"], ["\n  ", ";\n  color: ", ";\n  outline: none;\n  list-style: none;\n  padding-top: ", ";\n  display: flex;\n\n  > span {\n    flex: 0 1 auto;\n    sup {\n      line-height: 0;\n    }\n  }\n\n  &:first-child {\n    padding-top: 0;\n  }\n\n  > span:first-child {\n    &:before {\n      content: '\\u2022';\n      font-weight: ", ";\n      padding-right: ", ";\n      flex-grow: 0;\n    }\n  }\n\n  ul {\n    padding: 0;\n    margin: 0;\n    flex-shrink: 0;\n\n    li {\n      list-style: none;\n\n      &:first-child {\n        padding-top: ", ";\n      }\n\n      > span:first-child {\n        &::before {\n          content: '\\u2013';\n          font-weight: ", ";\n        }\n      }\n    }\n  }\n"])), function (_ref) {
    var n = _ref.$getFontStyles,
      e = _ref.size,
      t = _ref.viewport;
    return n(e, t);
  }, function (_ref2) {
    var n = _ref2.surface;
    return "dark" === n ? p : u;
  }, function (_ref3) {
    var n = _ref3.$paddingTop;
    return n;
  }, c, function (_ref4) {
    var n = _ref4.$paddingBullet;
    return n;
  }, function (_ref5) {
    var n = _ref5.$paddingTop;
    return n;
  }, f),
  x = function x(n) {
    var i = n.ariaLabel,
      a = n.children,
      l = n.size,
      s = n.viewport,
      u = n.tabIndex,
      p = n.surface,
      c = n.className,
      f = n.spacing,
      x = "mobile" === s ? "mobile" : "desktop";
    return e(w, {
      "aria-label": i,
      $getFontStyles: function $getFontStyles() {
        return "\n    font-family: ".concat("bodyLarge" === l || "bodyMedium" === l ? o.VerizonNHGeDS : o.VerizonNHGeTX, ";\n    font-size: ").concat(r(function () {
          switch (l) {
            case "micro":
              return d.fontsize.micro[11].value;
            case "bodySmall":
              return d.fontsize.body[12].value;
            case "bodyMedium":
              return d.fontsize.body[14].value;
            default:
              return d.fontsize.body[16].value;
          }
        }()), ";\n      font-weight: ").concat(d.fontweight.regular.value, ";\n      line-height: ").concat(r(function () {
          switch (l) {
            case "micro":
              return d.lineheight.micro[16].value;
            case "bodySmall":
              return d.lineheight.body[16].value;
            case "bodyMedium":
              return d.lineheight.body[18].value;
            default:
              return d.lineheight.body[20].value;
          }
        }()), ";\n      letter-spacing: ").concat(r(function (n, e) {
          var t = "0px";
          return "bodyLarge" !== n && "bodyMedium" !== n || "desktop" !== e || (t = d.letterspacing.wide.value), t;
        }(l, x)), ";\n    ");
      },
      size: l,
      tabIndex: u,
      viewport: x,
      surface: p,
      className: c,
      $paddingTop: "compact" === f ? "bodyLarge" === l ? m : y : "bodyLarge" === l ? g : h,
      $paddingBullet: "bodyLarge" === l ? v : b,
      children: [t("span", {
        "aria-hidden": !0
      }), t("span", {
        children: a
      })]
    });
  };
x.defaultProps = {
  size: "bodyLarge",
  viewport: "desktop",
  surface: "light"
}, x.displayName = "ListItem";
var $,
  z = a(x);
export { z as default };